<script>
	import Questions from "./Questions.svelte";
	import Findings from "./Findings.svelte";
	let view = Questions;
	function showView(newView) {
		view = newView;
		window.scroll(-1000, 0);
	}
</script>

<div class="iq-card">
	<div class="iq-header-title">
		<h3 class="card-title text-primary">
			Pediatric Head Injury Risk Predictor
		</h3>
	</div>
	<div class="iq-card-body p-0">
		<div class="row">
			<div>
				<svelte:component
					this={view}
					on:submitted={() => showView(Findings)}
					on:goback={() => showView(Questions)} />
			</div>
		</div>
	</div>
</div>
